import styled from "styled-components";

export const HomeSection = styled.section`
  min-height: 750px;
  min-width: 300px;
  width: 100%;
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
export const MusicSection = styled.section`
  min-width: 300px;
  width: 100%;
  position: relative;
`
